import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { interval } from 'rxjs';
import { AppSettings } from 'src/app/app-settings';
import { ApiSalesService } from 'src/app/services/api-sales.service';

@Component({
  selector: 'app-waiting-pay',
  templateUrl: './waiting-pay.component.html',
  styleUrls: ['./waiting-pay.component.scss']
})
export class WaitingPayComponent implements OnInit, OnDestroy {

  public progress = 0;
  public counter = 60;
  public tick = 0;
  public minutes = 1;
  public seconds = 0;

  idPayment: string = '';
  waiting: boolean = true;
  intervalId: any;

  totemActive: any = AppSettings.ENV_TOTEM;
  id_business_citylok!: any;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<WaitingPayComponent>, private apiSales: ApiSalesService) {

    this.idPayment = this.totemActive ? data.order_uuid : data.idPayment;
    this.id_business_citylok = data.id_business_citylok;
    setTimeout(() => {
      this.intervalId = setInterval(() => {
        this.counter = this.counter - 1;
        this.minutes = Math.floor(this.counter / 60);
        this.seconds = (this.counter - this.minutes * 60);
        if (this.seconds % 10)
          this.tick = this.tick + 1;
        // interval(10000).subscribe(val => this.validate())
        this.validate();
        if (this.counter === 0) {
          clearInterval(this.intervalId);
          this.validate(true);
        }
      }, 1000)
    }, 5000);
  }

  ngOnInit(): void {
    this.validate();
  }

  checkValid() {
    this.waiting = false;
    this.validate(true);
  }

  validate(fin?: boolean) {
    let count = 0;
    if (this.idPayment) {
      const payload = {
        order_uuid: this.idPayment,
        sale_channel: "totem",
        id_business_citylok: this.id_business_citylok
      }
      this.apiSales.getStatusTransactionWeb(this.idPayment).subscribe({
        next: (data) => {
          if (!this.totemActive) {
            if ((fin || count == 30) && data.paymentIntent.status != 'succeeded') {
              clearInterval(this.intervalId);
              this.dialogRef.close(data.paymentIntent.status)
            }
            if (data.status == 'succeeded') {
              clearInterval(this.intervalId);
              this.dialogRef.close('succeeded')
            }
          } else {
            if ((fin || count == 30) && data.data.status != 'paid') {
              this.cancelPay();
            }
            if (data.data.status == 'paid') {
              clearInterval(this.intervalId);
              this.dialogRef.close({ status: 'SUCCESS' });
            }
            if (data.data.status == 'cancelled' || data.data.status == 'refused') {
              this.cancelPay();
            }
          }
          count++;
        },
        error: (err) => {
          clearInterval(this.intervalId);
          this.dialogRef.close({ status: 'USER_CANCELLED' });
        }
      })
    }
  }

  cerrar() {
    this.validate(true);
  }

  cancelPay() {
    clearInterval(this.intervalId);
    this.dialogRef.close({ status: 'USER_CANCELLED' });
  }

  errPay() {
    clearInterval(this.intervalId);
    this.dialogRef.close({ status: 'USER_CANCELLED' });
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

}
